// @flow
import * as React from 'react';
import { type CategoryLink } from '../../types/CategoryLink';
import { connect } from 'react-redux';
import type { ExtractReturn } from '../../types/redux';
import { FormattedMessage } from 'react-intl';
import { getItem } from '../../redux/modules/item';
import { getItemFacets } from '../../redux/modules/itemFacets';
import { getMostPopularItemsByBids } from '../../redux/modules/filteredItems';
import { getSimilarItemsV3 } from '../../redux/modules/similarItemsV3';
import { getWindowSize } from '../../redux/modules/windowSize';
import { type ItemFacets } from '../../types/ItemFacets';
import SimilarItems from './SimilarItems';

type OwnProps = $ReadOnly<{|
    categoryLinks: CategoryLink[],
    centerHeader: boolean,
    className: string,
    itemId: number,
    suggestions: any[],
    title?: React.Node,
|}>;

const mapStateToProps = (state, { itemId, title }) => {
    let headerMessage = title || <FormattedMessage id="discover_similar_items" />;
    let linkMessage = <FormattedMessage id="see_all_similar_items" />;
    const item = getItem(state, itemId);
    const { title: itemTitle } = item;
    const { width } = getWindowSize(state);
    const facets = getItemFacets(state, itemId);

    let limit = width < 991 ? 12 : 15;
    let similarItems = getSimilarItemsV3(state, itemId, limit); // reduced cardViewModel data structure
    if (similarItems.length === 0) {
        linkMessage = <FormattedMessage id="see_all" />;
        similarItems = getMostPopularItemsByBids(state, item.sellerId);
        headerMessage = <FormattedMessage id="bid_most_popular_items" />;
    }

    return {
        facets,
        headerMessage,
        itemTitle,
        linkMessage,
        similarItems,
        width,
    };
};
type ReduxProps = $ReadOnly<{|
    ...ExtractReturn<typeof mapStateToProps>,
    facets: ItemFacets,
    headerMessage: React.Node,
    itemTitle: string,
    linkMessage: React.Node,
    similarItems: any[],
    width: number,
|}>;

type Props = $ReadOnly<{|
    ...OwnProps,
    ...ReduxProps,
|}>;

class SimilarItemsContainer extends React.Component<Props> {
    static defaultProps = {
        categoryLinks: [],
        suggestions: [],
    };

    render() {
        const {
            categoryLinks,
            centerHeader,
            className,
            facets,
            headerMessage,
            itemTitle,
            linkMessage,
            similarItems,
            suggestions,
            width,
        } = this.props;

        return (
            <SimilarItems
                categoryLinks={categoryLinks}
                centerHeader={centerHeader}
                className={className}
                facets={facets}
                headerMessage={headerMessage}
                itemTitle={itemTitle}
                linkMessage={linkMessage}
                similarItems={similarItems}
                suggestions={suggestions}
                width={width}
            />
        );
    }
}

export default connect(mapStateToProps)(SimilarItemsContainer);
